<div class="layout-wrapper" [ngClass]="{
    'layout-overlay': app.menuMode === 'overlay',
    'layout-static': app.menuMode === 'static',
    'layout-slim': app.menuMode === 'slim',
    'layout-sidebar-dim': app.colorScheme === 'dim',
    'layout-sidebar-dark': app.colorScheme === 'dark',
    'layout-overlay-active': overlayMenuActive,
    'layout-mobile-active': staticMenuMobileActive,
    'layout-static-inactive': staticMenuDesktopInactive && app.menuMode === 'static',
    'p-input-filled': app.inputStyle === 'filled', 'p-ripple-disabled': !app.ripple}"
    [class]="app.colorScheme === 'light' ? app.menuTheme : ''"
    (click)="onLayoutClick()">

    <p-confirmDialog #confirmChanges key="save-changes" attachTo="body" position="top" [style]="{width: 'min-content'}">
        <ng-template pTemplate="headless" let-message>
            <div class="flex flex-column gap-2 border-round p-3">
                <div class="flex align-items-center gap-2">
                    <i class="pi pi-exclamation-triangle" style="font-size: 2rem;"></i>
                    <p>Vous avez peut-être des <b>modifications non sauvegardées</b>. Voulez-vous vraiment naviguer vers une autre page ?</p>
                </div>
                <div class="flex align-items-center gap-2 mt-3 mr-6">
                    <p-splitButton label="Sauvegarder" [model]="saveAndQuitItems" (onClick)="onClosePromise.next(CloseEvent.SaveAndQuit)"></p-splitButton>
                    <p-button label="Annuler" [outlined]="true" (onClick)="onClosePromise.next(CloseEvent.Cancel)"></p-button>
                </div>
            </div>
        </ng-template>
    </p-confirmDialog>

    <app-menu></app-menu>

    <p-scrollTop [threshold]="200" icon="pi pi-arrow-up" />

    <div class="layout-content-wrapper">
        <app-topbar></app-topbar>
        <div class="layout-content">
            <p-blockUI [blocked]="mainBlocked">
                <div class="fluid formgrid grid">
                    <div class="flex flex-column gap-2 col-12 text-center">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                </div>
            </p-blockUI>

            <router-outlet></router-outlet>

            <p-sidebar [(visible)]="afficherDetailItem" [style]="{width:'95%'}" position="left">
                <app-detail-item [itemId]="detailItemId" *ngIf="afficherDetailItem"></app-detail-item>
            </p-sidebar>

            <p-sidebar [(visible)]="afficherDetailBonTravail" [style]="{width:'95%'}" position="left">
                <app-detail-bdt [bdtId]="detailBonTravailId" *ngIf="afficherDetailBonTravail"></app-detail-bdt>
            </p-sidebar>
        </div>

        <app-footer class="sticky bottom-0 right-0 w-full "></app-footer>
    </div>

    <!--    <app-config></app-config> -->

    <app-search></app-search>

    <div class="layout-mask modal-in"></div>
</div>